module.exports = __webpack_public_path__ + "img/menu.f993c43c.svg";